import { Box, Button, ButtonColor, ButtonPull, FormInput } from '@alirosoftware/web-components';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ForgotPasswordInput, useForgotPasswordMutation } from '../../../graphql/_generated';
import { FormServerError } from '../../shared/forms/server-error';
import { HiOutlineMail } from 'react-icons/hi';

type ForgotPasswordFormProps = {
  onSent: (email: string) => void;
};

export const ForgotPasswordForm = ({ onSent }: ForgotPasswordFormProps) => {
  const { t } = useTranslation();

  const [forgotPassword, { error }] = useForgotPasswordMutation();

  const onSubmit = async (input: ForgotPasswordInput) => {
    await forgotPassword({ variables: { input }, onCompleted: () => onSent(input.email) });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
  });

  return (
    <>
      <h1 className="u-mb-4">{t('forgotPassword')}</h1>
      <Box className="card card-vertical">
        <p className="center">{t('forgotPasswordDesc')}</p>
        <Formik<ForgotPasswordInput>
          onSubmit={onSubmit}
          initialValues={{ email: '' }}
          validationSchema={validationSchema}
          validateOnBlur={true}
          validateOnChange={false}
        >
          {({ handleSubmit, isSubmitting, submitForm }) => (
            <form onSubmit={handleSubmit}>
              <FormServerError error={error} />
              <FormInput
                name="email"
                label={t('email')}
                placeholder={t('email')}
                tabIndex={1}
                autoFocus
                icon={HiOutlineMail}
              />
              <Button
                color={ButtonColor.Primary}
                onClick={submitForm}
                loading={isSubmitting}
                pull={ButtonPull.Right}
                tabIndex={2}
                testId="send-email"
              >
                {t('sendPasswordResetEmail')}
              </Button>
            </form>
          )}
        </Formik>
      </Box>
    </>
  );
};
